/**
 * @project E-School Web
 * @author Vothana CHY
 * @date 2026-07-28
 */

export const PREDEFINED_GRADES = [
  { value: 'all', labelKh: 'គ្រប់កម្រិត (All Grades)', labelEn: 'All Grades' },
  { value: 'ថ្នាក់ទី១២', labelKh: 'ថ្នាក់ទី១២ (Grade 12)', labelEn: 'Grade 12' },
  { value: 'ថ្នាក់ទី១១', labelKh: 'ថ្នាក់ទី១១ (Grade 11)', labelEn: 'Grade 11' },
  { value: 'ថ្នាក់ទី១០', labelKh: 'ថ្នាក់ទី១០ (Grade 10)', labelEn: 'Grade 10' },
  { value: 'ថ្នាក់ទី៩', labelKh: 'ថ្នាក់ទី៩ (Grade 9)', labelEn: 'Grade 9' },
  { value: 'ថ្នាក់ទី៨', labelKh: 'ថ្នាក់ទី៨ (Grade 8)', labelEn: 'Grade 8' },
  { value: 'ថ្នាក់ទី៧', labelKh: 'ថ្នាក់ទី៧ (Grade 7)', labelEn: 'Grade 7' },
  { value: 'ថ្នាក់ទី៦', labelKh: 'ថ្នាក់ទី៦ (Grade 6)', labelEn: 'Grade 6' },
  { value: 'ថ្នាក់ទី៥', labelKh: 'ថ្នាក់ទី៥ (Grade 5)', labelEn: 'Grade 5' },
  { value: 'ថ្នាក់ទី៤', labelKh: 'ថ្នាក់ទី៤ (Grade 4)', labelEn: 'Grade 4' },
  { value: 'ថ្នាក់ទី៣', labelKh: 'ថ្នាក់ទី៣ (Grade 3)', labelEn: 'Grade 3' },
];

export const PREDEFINED_SUBJECTS = [
  { value: 'all', labelKh: 'ទាំងអស់ (All)', labelEn: 'All' },
  { value: 'គណិតវិទ្យា', labelKh: 'គណិតវិទ្យា (Mathematics)', labelEn: 'Mathematics' },
  { value: 'រូបវិទ្យា', labelKh: 'រូបវិទ្យា (Physics)', labelEn: 'Physics' },
  { value: 'គីមីវិទ្យា', labelKh: 'គីមីវិទ្យា (Chemistry)', labelEn: 'Chemistry' },
  { value: 'ជីវវិទ្យា', labelKh: 'ជីវវិទ្យា (Biology)', labelEn: 'Biology' },
  { value: 'អក្សរសាស្ត្រខ្មែរ', labelKh: 'អក្សរសាស្ត្រខ្មែរ (Khmer Literature)', labelEn: 'Khmer Literature' },
  { value: 'ភាសាអង់គ្លេស', labelKh: 'ភាសាអង់គ្លេស (English)', labelEn: 'English' },
  { value: 'ប្រវត្តិវិទ្យា', labelKh: 'ប្រវត្តិវិទ្យា (History)', labelEn: 'History' },
  { value: 'ភូមិវិទ្យា', labelKh: 'ភូមិវិទ្យា (Geography)', labelEn: 'Geography' },
];
